import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import uuid from 'uuid/v4';
import rowsIcon from '../../../images/rows_icon_normal_state.png';
import columnsIcon from '../../../images/columns_icon_normal_state.png';
import basesIcon from '../../../images/bases_icon_normal_state.png';
import rowsHoverIcon from '../../../images/rows_icon_hover_state.png';
import basesHoverIcon from '../../../images/bases_icon_hover_state.png';
import columnsHoverIcon from '../../../images/columns_icon_hover_state.png';
import targetIcon from '../../../images/target-icon_blue.png';
import targetHoverIcon from '../../../images/target-hover_icon.png';
import { getActionName } from '../../../util/trackerUtils';
import { ACTION_TYPE_CUSTOM_DROPDOWN, SMARTSEARCH_NORESULTS_FOUND } from '../../../constants';
import { MME_MODULE } from '../../mme/MMEConstants';
import { isNielsenStudyPresent } from '../../../util/CrosstabUtils';
import { GEO_MAP_MODULE } from '../../geoMap/GeoMapConstant';

class CategorizedCustomDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptions: [],
      shiftSelectedLastIndex: -1,
      dynamicSuggestions: this.props.suggestions,
      currentLength: 100,
      isScrollAtBottom: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.suggestions !== this.props.suggestions && nextProps.suggestions.length > 100) {
      this.setState({
        dynamicSuggestions: nextProps.suggestions.slice(0, 100),
        currentLength: 100,
        isScrollAtBottom: false,
      });
    } else if (nextProps.suggestions !== this.props.suggestions) {
      this.setState({
        dynamicSuggestions: nextProps.suggestions,
        currentLength: 100,
        isScrollAtBottom: false,
      });
    }
    if (
      nextProps.suggestions !== this.props.suggestions &&
      this.state.selectedOptions.length
    ) {
      this.setState({ selectedOptions: [], shiftSelectedLastIndex: -1 });
    }
  }

  getSuggestionClass = (recordTag, scope, moduleType) => {
    if (recordTag === 'C' || recordTag === 'S' || recordTag === 'T') {
      return 'folder';
    }
    if (recordTag === 'D') {
      let iconType = 'definition-green';
      switch (scope) {
        case 1:
          iconType = 'definition-light-green';
          break;
        case 2:
          iconType = 'definition-purple';
          break;
        case 3:
          iconType = 'definition-light-purple';
          break;
        case 4:
          iconType = 'definition-yellow';
          break;
        case 5:
          iconType = 'definition-light-yellow';
          break;
        default:
          iconType = 'definition-green';
      }
      return iconType;
    }

    if (moduleType === 'QTS') {
      let qtsIconType = 'qts-purple';
      switch (recordTag) {
        case 'C':
          qtsIconType = 'folder--qts';
          break;
        case 'S':
          qtsIconType = 'folder--qts';
          break;
        case 'T':
          qtsIconType = 'folder--qts';
          break;
        case 'Q':
          qtsIconType = 'question--qts';
          break;
        default:
          qtsIconType = 'qts-purple';
      }
      return qtsIconType;
    }

    if (recordTag === 'Q') {
      return 'question';
    }

    return '';
  };

  getRange = (start, end) => {
    let aStart = start;
    let aEnd = end;
    if (start > end) {
      const temp = aStart;
      aStart = aEnd;
      aEnd = temp;
    }
    return Array((aEnd - aStart) + 1)
      .fill()
      .map((_, idx) => aStart + idx);
  };

  // icon mouseOver
  mouseOver = e => {
    const event = e;
    event.currentTarget.childNodes[0].src =
      event.currentTarget.childNodes[0].dataset.hoversrc;
  };

  // icon mouseOut
  mouseOut = e => {
    const event = e;
    event.currentTarget.childNodes[0].src =
      event.currentTarget.childNodes[0].dataset.src;
  };

  selectSuggestion = (e, item, selectedIndex) => {
    let newItem = item;
    if (e.ctrlKey || e.metaKey) {
      if (newItem.recType !== 'H') {
        if (newItem.recType === 'G') {
          newItem = {
            ...newItem,
            keyword: ` IN${newItem.category} ( ${newItem.node} ) `,
          };
        } else if (newItem.recType === 'N') {
          if (isNielsenStudyPresent(newItem.pathId)) {
            newItem = {
              ...newItem,
              keyword: `${newItem.keyword} >= 1`,
            };
          }
        }
        const selectedOptions = this.state.selectedOptions.filter(
          fItem => fItem.node === newItem.node,
        ).length
          ? this.state.selectedOptions.filter(fItem => fItem.node !== newItem.node)
          : [...this.state.selectedOptions, newItem];
        this.setState({
          selectedOptions,
          shiftSelectedLastIndex: selectedIndex,
        });
      }
    } else if (e.shiftKey) {
      let selectedOptions = [];
      if (newItem.recType !== 'H') {
        if (this.state.shiftSelectedLastIndex >= 0) {
          const selectedShiftItems = [];
          const selectedRangeArray = this.getRange(
            this.state.shiftSelectedLastIndex,
            selectedIndex,
          );
          selectedRangeArray.map(idx => {
            if (this.props.suggestions[idx].recType !== 'H') {
              if (this.props.suggestions[idx].recType === 'G') {
                this.props.suggestions[idx] = {
                  ...this.props.suggestions[idx],
                  keyword: ` IN${this.props.suggestions[idx].category} ( ${
                    this.props.suggestions[idx].node
                    } ) `,
                };
              } else if (this.props.suggestions[idx].recType === 'N') {
                if (isNielsenStudyPresent(this.props.suggestions[idx].pathId)) {
                  this.props.suggestions[idx] = {
                    ...this.props.suggestions[idx],
                    keyword: `${this.props.suggestions[idx].keyword} >= 1`,
                  };
                }
              }
              selectedShiftItems.push(this.props.suggestions[idx]);
            }
            return true;
          });
          selectedOptions = [...selectedShiftItems];
        } else {
          selectedOptions = [...this.state.selectedOptions, newItem];
        }
        this.setState({
          selectedOptions,
          shiftSelectedLastIndex: selectedIndex,
        });
      }
    } else {
      if (newItem.recType === 'G') {
        newItem = {
          ...newItem,
          keyword: ` IN${newItem.category} ( ${newItem.node} ) `,
        };
      } else if (newItem.recType === 'N') {
        if (isNielsenStudyPresent(newItem.pathId)) {
          newItem = {
            ...newItem,
            keyword: `${newItem.keyword} >= 1`,
          };
        }
      }
      this.callHandleSelect(newItem);
    }
  };

  callHandleSelect = selectedItem => {
    // selectedItem = [item];
    this.setState({ selectedOptions: [selectedItem] }, () => {
      if (this.state.selectedOptions.length === 1) {
        this.props.handleSelect(this.state.selectedOptions, null);
      }
    });
  };

  handleAdd = () => {
    if (this.props.suggestions) {
      if (this.props.suggestions.length === 1) {
        this.callHandleSelect(this.props.suggestions[0]);
      } else {
        const perfectMatch = this.props.suggestions.filter(
          ({ shortText }) =>
            shortText.toUpperCase() === this.props.inputValue.toUpperCase(),
        );
        if (perfectMatch.length > 0) {
          this.callHandleSelect(perfectMatch[0]);
        }
      }
    }
  };

  handleOperator = selectedOperator => {
    const action = getActionName(ACTION_TYPE_CUSTOM_DROPDOWN, selectedOperator);
    if (action !== '') {
      this.props.trackerFn({ action, attributes: { expression: this.state.selectedOptions } });
    }
    this.props.handleSelect(this.state.selectedOptions, selectedOperator);
    this.setState({ selectedOptions: [], shiftSelectedLastIndex: -1 });
  };

  renderSuggestionsDynamically = e => {
    const suggestions = [...this.props.suggestions];
    const currentLength = this.state.currentLength;
    let nextLength = currentLength + 100;
    if (suggestions.length < currentLength + 100) {
      nextLength = suggestions.length;
    }
    if ($(e.target).scrollTop() + $(e.target).innerHeight() >= $(e.target)[0].scrollHeight - 10) {
      if (nextLength <= suggestions.length) {
        if (nextLength === suggestions.length && !this.state.isScrollAtBottom) {
          const nextSetSuggestion = _.cloneDeep(suggestions).splice(0, nextLength);
          this.setState({
            dynamicSuggestions: nextSetSuggestion,
            currentLength: nextLength,
            isScrollAtBottom: true,
          });
        } else if (!this.state.isScrollAtBottom) {
          const nextSetSuggestion = _.cloneDeep(suggestions).splice(0, nextLength);
          this.setState({ dynamicSuggestions: nextSetSuggestion, currentLength: nextLength });
        }
      }
    }
  }

  renderSuggestions = () =>
    this.state.dynamicSuggestions.map((item, index) => (
      <div
        key={uuid()}
        data-listid={this.props.uniqueId}
        className={`option ${this.getSuggestionClass(
          item.recordTag,
          item.scope,
          item.moduleType
        )} ${
          this.state.selectedOptions.filter(fItem => fItem.node === item.node)
            .length
            ? 'selected'
            : ''
        }
        ${item.shortTextCatgView === '(' || item.shortTextCatgView === 'NOT'
        || item.shortTextCatgView === ')' || item.shortTextCatgView === 'AND'
        || item.shortTextCatgView === 'XOR' || item.shortTextCatgView === 'OR'
        ? 'option-not-openbracket' : ''}
      `}
        onClick={e => this.selectSuggestion(e, item, index)}
        title={
          item.shortTextPrifix
            ? `${item.shortTextPrifix}. ${item.shortTextCatgView}
${item.breadcrumbs}`
            : item.shortTextCatgView
        }
      >
        {this.highlightMatchedWord(this.renderSuggestionsText(item))}
        {item.objectType === 'operand' && (
          <div
            data-listid={this.props.uniqueId}
            className="suggesttion-breadcrumb"
          >{this.highlightMatchedWord(item.breadcrumbs)}</div>
        )}

      </div>
    ));

  renderSuggestionsText = item => {
    switch (item.shortTextPrifix) {
      case 'F':
        return `${item.shortTextCatgView}`;
      case 'Q':
        return `${item.shortTextCatgView}`;
      case 'A':
        return `${item.shortTextCatgView}`;
      case 'D':
        return `${item.shortTextCatgView}`;
      case 'AD':
        return `${item.shortTextCatgView}`;
      default:
        return item.shortTextCatgView;
    }
  };

  renderButtons = () => {
    if (this.props.selectedModule === 'quickReports' || this.props.selectedModule === MME_MODULE) {
      return (
        <div className="large-9 display-inline text-right">
          <div className="display-inline text-center">
            <button
              type="button"
              onMouseOver={this.mouseOver}
              onMouseOut={this.mouseOut}
              className={
                this.state.selectedOptions.length <= 1
                  ? 'smartsearch-hidden'
                  : 'button medium button-move'
              }
              onClick={this.props.selectedModule === MME_MODULE ? () => this.handleOperator('BasesDataGrid') : () => this.handleOperator('BaseDataGrid')}
              title="Move to base"
            >
              <img
                src={basesIcon}
                data-src={basesIcon}
                data-hoversrc={basesHoverIcon}
                alt="Move to base"
              />
            </button>
          </div>
          <div className="display-inline text-center">
            <button
              type="button"
              onMouseOver={this.mouseOver}
              onMouseOut={this.mouseOut}
              className={
                this.state.selectedOptions.length <= 1
                  ? 'smartsearch-hidden'
                  : 'button medium button-move'
              }
              onClick={this.props.selectedModule === MME_MODULE ? () => this.handleOperator('TargetsDataGrid') : () => this.handleOperator('TargetDataGrid')}
              title="Move to target"
            >
              <img
                src={this.props.selectedModule === MME_MODULE ? targetIcon : columnsIcon}
                data-src={this.props.selectedModule === MME_MODULE ? targetIcon : columnsIcon}
                data-hoversrc={this.props.selectedModule === MME_MODULE ? targetHoverIcon : columnsHoverIcon}
                alt="Move to target"
              />
            </button>
          </div>
        </div>
      );
    }
    return (
      <div className="large-9 display-inline text-right">
        <div className="display-inline text-center">
          <button
            type="button"
            onMouseOver={this.mouseOver}
            onMouseOut={this.mouseOut}
            className={
              this.state.selectedOptions.length <= 1
                ? 'smartsearch-hidden'
                : 'button medium button-move'
            }
            onClick={this.props.dataScreen !== 'DataHaul'
              ? () => this.handleOperator('BasesDataGrid')
              : () => this.handleOperator('DataHaulBasesDataGrid')}
            disabled={this.props.study.toLowerCase().includes('slcl')}
            title={
              this.props.study.toLowerCase().includes('slcl')
                ? 'You can select only one base for flexible market study'
                : 'Move to base'
            }
          >
            <img
              src={basesIcon}
              data-src={basesIcon}
              data-hoversrc={basesHoverIcon}
              alt="Move to bases"
            />
          </button>
        </div>
        <div className="display-inline text-center">
          <button
            type="button"
            onMouseOver={this.mouseOver}
            onMouseOut={this.mouseOut}
            className={
              this.state.selectedOptions.length <= 1
                ? 'smartsearch-hidden'
                : 'button medium button-move'
            }
            onClick={this.props.dataScreen !== 'DataHaul'
              ? () => this.handleOperator('ColumnsDataGrid')
              : () => this.handleOperator('DataHaulColumnsDataGrid')}
            title="Move to columns"
          >
            <img
              src={columnsIcon}
              data-src={columnsIcon}
              data-hoversrc={columnsHoverIcon}
              alt="Move to columns"
            />
          </button>
        </div>
        <div className="display-inline text-center">
          <button
            type="button"
            onMouseOver={this.mouseOver}
            onMouseOut={this.mouseOut}
            className={
              this.state.selectedOptions.length <= 1
                ? 'smartsearch-hidden'
                : 'button medium button-move'
            }
            onClick={() => this.handleOperator('RowsDataGrid')}
            title="Move to rows"
            disabled={this.props.dataScreen}
          >
            <img
              src={rowsIcon}
              data-src={rowsIcon}
              data-hoversrc={rowsHoverIcon}
              alt="Move to rows"
            />
          </button>
        </div>
      </div>
    );
  };

  highlightMatchedWord = text => {
    const formattedWithHyphen = text.replace(/-/g, ' - ');
    const answers = formattedWithHyphen ? formattedWithHyphen.split(' ') : [];
    const searchText = this.props.inputValue.trim().split(' ');
    const newAnswers = [];
    answers.forEach(element => {
      let queryFlag = false;
      searchText.forEach(query => {
        if (query.trim().length) {
          const regex = /(\s*)([^\w\s])(\s*)/gi;
          let string;
          if (element.includes('$')) {
            string = element.toLowerCase();
          } else {
            string = element.toLowerCase().replace(regex, '');
          }
          // const string = element.toLowerCase().replace(/[^a-zA-Z ]/gi, '');
          if (string.startsWith(query.trim().toLowerCase())) {
            queryFlag = true;
          }
        }
      });
      if (queryFlag) {
        newAnswers.push(<span key={uuid()} style={{ color: '#991a41', fontWeight: 'bold' }}> {element} </span>);
      } else {
        if (element === '>') {
          newAnswers.push(<span key={uuid()} className="breadcrumb-seperator"> {element} </span>);
        } else {
          newAnswers.push(<span key={uuid()}> {element} </span>);
        }
      }
    });
    return newAnswers;
  };

  renderBool = () => {
    return (<div
      className="invalid-operand-search"
    >Invalid entry. To proceed select a boolean operator.
    </div>);
  }

  renderDropdown = () => {
    if (this.props.suggestions.length > 0) {
      return (
        <div
          className={
            this.state.selectedOptions.length <= 1
              ? 'smartsearch-hidden'
              : 'moveto-drop-down'
          }
        >
          <div
            className={
              this.state.selectedOptions.length <= 1
                ? 'smartsearch-hidden'
                : 'multiple-select-group-button clearfix'
            }
          >
            <div className="large-12">
              <div className="large-3 display-inline and-or-button-group">
                <button
                  type="button"
                  className={
                    this.state.selectedOptions.length <= 1
                      ? 'smartsearch-hidden'
                      : 'button medium button-operator'
                  }
                  disabled={this.state.selectedOptions.length <= 1}
                  onClick={() => this.handleOperator('AND')}
                >
                  AND
                </button>
                <span>/</span>
                <button
                  type="button"
                  className={
                    this.state.selectedOptions.length <= 1
                      ? 'smartsearch-hidden'
                      : 'button medium button-operator'
                  }
                  onClick={() => this.handleOperator('OR')}
                >
                  OR
                </button>
              </div>
              {this.props.selectedModule !== 'insight360' &&
                this.props.selectedModule !== 'salescatalyst' &&
                this.props.selectedModule !== 'visahaul' &&
                this.props.selectedModule !== 'userPreferences' &&
                this.props.selectedModule !== GEO_MAP_MODULE
                ? this.renderButtons()
                : ''}
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  render() {
    if (!this.props.tagFocus) {
      return <div />;
    }
    if (this.props.suggestions.length === 0) {
      if (this.props.inputValue.length > 2) {
        return (
          <div className="categorized-smartsearch-dropdown-box">
            <div className="smartsearch-dropdown-list">
              <div className="nooption">
                {SMARTSEARCH_NORESULTS_FOUND}
              </div>
            </div>
          </div>
        );
      }

      return <div />;
    }
    return (
      <div
        onMouseEnter={() => this.props.dropdownBlur(true)}
        onMouseLeave={() => this.props.dropdownBlur(false)}
        className={`categorized-smartsearch-dropdown-box ${_.isEmpty(this.props.categoryList)
          ? '' : 'suggestion-box-border'}`}
        onScroll={this.renderSuggestionsDynamically}
      >
        {this.renderDropdown()}
        <div
          className={`smartsearch-dropdown-list ${_.isEmpty(this.props.categoryList)
            ? '' : 'suggestion-box-border'}`} data-listid={this.props.uniqueId} id="smart-search-list"
        >
          {this.props.isOperandSearch ? this.renderBool() : ''}
          {this.renderSuggestions()}
        </div>
      </div>
    );
  }
}

CategorizedCustomDropdown.propTypes = {
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      recType: PropTypes.string,
      category: PropTypes.string,
      node: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  ),
  inputValue: PropTypes.string,
  selectedModule: PropTypes.string,
  tagFocus: PropTypes.bool,
  uniqueId: PropTypes.string,
  trackerFn: PropTypes.func,
  handleSelect: PropTypes.func,
  dropdownBlur: PropTypes.func,
  dataScreen: PropTypes.string,
  study: PropTypes.string,
  categoryList: PropTypes.instanceOf(Array),
  isOperandSearch: PropTypes.bool,
};

export default CategorizedCustomDropdown;
